module.exports = __webpack_public_path__ + "img/sage.8afae02e.png";